export default "__VITE_ASSET__BFK6oWRu__"